import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faXTwitter,
  faInstagram,
  faLinkedin,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";

const SocialMediaButton = ({ platform, link }) => {
  const renderButton = () => {
    switch (platform) {
      case "Facebook":
        return (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="icon-button"
          >
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        );
      case "Twitter":
        return (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="icon-button"
          >
            <FontAwesomeIcon icon={faXTwitter} />
          </a>
        );
      case "Instagram":
        return (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="icon-button"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        );
      case "LinkedIn":
        return (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="icon-button"
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
        );
      case "TikTok":
        return (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="icon-button"
          >
            <FontAwesomeIcon icon={faTiktok} />
          </a>
        );
      default:
        return null;
    }
  };

  return <div className="social-button">{renderButton()}</div>;
};

export default SocialMediaButton;
